export const RECEIVE_OTHER_REGISTRIES = 'zola/registry/RECEIVE_OTHER_REGISTRIES';
export const VALIDATE_URL_ERROR = 'zola/registry/TEST_VALIDATE_URL_ERROR';
